import { renderDsDateTimePicker } from '../../../../../shared-ui/ds/dateTimePicker.js';
import { isSettingsSaasFinalUiActive, withSettingsPresentationMode } from './settingsPresentationMode.js';

export function renderSettingsDateTimeField(options = {}) {
  const normalized = withSettingsPresentationMode(options);
  const finalUi = isSettingsSaasFinalUiActive();
  const triggerClass = String(normalized.triggerClass || '').trim();
  const className = ['kg-settings-datetime-field', triggerClass.includes('mini') ? 'kg-settings-datetime-field--mini' : '']
    .filter(Boolean)
    .join(' ');
  const inputType = String(
    normalized.inputAttrs && typeof normalized.inputAttrs === 'object' && normalized.inputAttrs.type
      ? normalized.inputAttrs.type
      : 'datetime-local'
  ).trim() || 'datetime-local';
  const html = renderDsDateTimePicker({
    ...normalized,
    id: '',
    inputId: String(normalized.id || normalized.inputId || '').trim(),
    label: '',
    helperText: '',
    size: triggerClass.includes('mini') ? 'sm' : 'md',
    mode: normalized.mode || 'dateTime',
    className,
    iconLeftHtml: finalUi ? '<span class="kg-settings-final-date-icon"></span>' : '\u{1F4C5}',
    inputAttrs: {
      type: 'datetime-local',
      ...(normalized.inputAttrs && typeof normalized.inputAttrs === 'object' ? normalized.inputAttrs : {})
    }
  });
  return html.replace(' type="text"', ` type="${escapeAttribute(inputType)}"`);
}

function escapeAttribute(value = '') {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}
